import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'

export const getCashBankListReq = (action) => {
    const { societyId, year } = action?.data || {};
    const url = apiEndpoints.GET_CASH_BANK_LIST_API.replace(':societyId', societyId);
    return axiosInstance.get(url, { params: { year } });
}

export const getCashBankEntriesReq = (action) => {
    const { societyId, glCode, year, fromDate, toDate, category, transactionType, search } = action?.data || {};
    const url = apiEndpoints.GET_CASH_BANK_ENTRIES_API
        .replace(':societyId', societyId)
        .replace(':glCode', glCode);
    const params = { year };
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    if (category && category !== 'all') params.category = category;
    if (transactionType && transactionType !== 'all') params.transactionType = transactionType;
    if (search) params.search = search;
    return axiosInstance.get(url, { params });
}

export const getCashBankSummaryReq = (action) => {
    const { societyId, glCode, year, fromDate, toDate } = action?.data || {};
    const url = apiEndpoints.GET_CASH_BANK_SUMMARY_API
        .replace(':societyId', societyId)
        .replace(':glCode', glCode);
    const params = { year };
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    return axiosInstance.get(url, { params });
}
